import { render, staticRenderFns } from "./ReportReason.vue?vue&type=template&id=ca87e9ac"
import script from "./ReportReason.vue?vue&type=script&lang=js"
export * from "./ReportReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports